import { IGuest } from '@bridebook/models/source/models/Weddings/Guests.types';
import { GuestlistActionTypes } from '@bridebook/web/lib/guestlist/action-types';
import { initialisedGuestlistAnalytics } from '@bridebook/web/lib/guestlist/analytics/actions';
import { InitialisedGuestListStorage } from '@bridebook/web/lib/storage-manager/basic/initialised-guest-list';
import { TrackingEvent } from '@bridebook/web/lib/track-utils/tracking-event';
import { IDeps } from '@bridebook/web/lib/types';

export const onFirebaseGuestlist = (guests: Array<IGuest>) => ({
  type: GuestlistActionTypes.ON_FIREBASE_GUESTLIST,
  payload: guests,
});

export const initEmptyGuestlist =
  () =>
  ({ dispatch, cordovaTracker }: IDeps) => {
    InitialisedGuestListStorage.set(true);
    cordovaTracker.track(TrackingEvent.InitializedGuestList);
    dispatch(initialisedGuestlistAnalytics('emptyGuestList'));
    return {
      type: GuestlistActionTypes.INIT_EMPTY_GUESTLIST,
    };
  };

export const updateGuestsMissingEmail = (count: number) => ({
  type: GuestlistActionTypes.UPDATE_GUESTS_MISSING_EMAIL,
  payload: count,
});
